import { Renderer } from 'amis';
import { RendererProps } from 'amis';
import React from 'react';
import AISvgLayout from './components/layout/AISvgLayout';

export interface AISvgPluginProps extends RendererProps {
  target?: string;
}

const AISvg: React.FC<AISvgPluginProps> = () => {
  return <AISvgLayout />;
};

@Renderer({
  test: /\bagimx-ai-svg$/,
  name: 'agimx-ai-svg',
})
export default class AISvgPlugin extends React.Component<AISvgPluginProps> {
  static defaultProps = {
    target: 'world',
  };

  render() {
    return <AISvg {...this.props} />;
  }
}